// Presentation only: balances and transaction order come from the wallet API.
const money = (value) => {
  if (value === null || value === undefined || value === '' || !Number.isFinite(Number(value))) {
    throw new Error('Statement balances are unavailable. Please reload and try again.')
  }
  return Math.round(Number(value) * 100) / 100
}

export function validateStatementDates(startDate = '', endDate = '') {
  for (const value of [startDate, endDate]) {
    if (value && (!/^\d{4}-\d{2}-\d{2}$/.test(value) ||
      Number.isNaN(Date.parse(value)) || new Date(value).toISOString().slice(0, 10) !== value)) {
      throw new Error('Choose a valid statement date.')
    }
  }
  if (startDate && endDate && startDate > endDate) {
    throw new Error('The start date must be before the end date.')
  }
}

export function buildWalletStatementData(payload, options = {}) {
  validateStatementDates(options.startDate, options.endDate)
  if (!Array.isArray(payload?.transactions)) throw new Error('The wallet statement could not be loaded.')
  const rows = payload.transactions.filter(tx => !tx.synthetic).map(tx => ({
    timestamp: tx.timestamp,
    description: String(tx.description || ''),
    amount: money(tx.amount),
    balance: money(tx.runningBalance ?? tx.balanceAfter),
    fee: money(tx.cost ?? 0),
  })).reverse()
  // Reversing the API's newest-first rows also preserves its equal-time ordering.
  const creditCents = rows.reduce((sum, row) => sum + Math.max(0, Math.round(row.amount * 100)), 0)
  const debitCents = rows.reduce((sum, row) => sum + Math.max(0, -Math.round(row.amount * 100)), 0)
  return {
    accountName: options.accountName || 'Account holder',
    startDate: options.startDate || '',
    endDate: options.endDate || '',
    generatedAt: options.generatedAt || new Date(),
    openingBalance: money(payload.openingBalance),
    closingBalance: money(payload.closingBalance),
    credits: creditCents / 100,
    debits: debitCents / 100,
    hasFees: rows.some(row => row.fee !== 0),
    rows,
  }
}
